import React from 'react';

import WaitingRoomContent from '../WaitingRoomContent';

function BetreadyRoomContent({ viewProps }) {
  return <WaitingRoomContent viewProps={viewProps} />;
}

export default BetreadyRoomContent;
